import styled from '@emotion/styled'
import {
  MdInfo,
  MdCheckCircle,
  MdWarning,
  MdSentimentSatisfied,
  MdError,
} from 'react-icons/md'
import { PrimaryButton } from '@mmsg/louie'
import { Col } from 'react-bootstrap'
import { AccordionCard } from 'components/accordion'

export const AlertBannerDiv = styled.div`
  label: AlertBannerDiv;
  margin-top: 45px;
  margin-bottom: 60px;
  max-width: 1077px;
  padding-left: 30px;
  div > svg {
    height: auto;
  }
  @media (max-width: 719px) {
    padding-left: 0px;
    margin-top: 85px;
  }
`

export const BannerPrimaryButton = styled(PrimaryButton)`
  label: BannerPrimaryButton;
  background: #fff !important;
  color: #000 !important;
  border-color: #fff !important;
  min-width: 324px;
  @media (max-width: 719px) {
    font-weight: 600 !important;
    padding: 9px 18px !important;
    min-width: 214px;
  }
`

export const BannerPrimaryInverted = styled(PrimaryButton)`
  label: BannerPrimaryButton;
  color: #fff !important;
  background: ${(props) => props.theme.colors.primary} !important;
  border-color: ${(props) => props.theme.colors.primary} !important;
  min-width: 324px;
  @media (max-width: 719px) {
    font-weight: 600 !important;
    padding: 9px 18px !important;
    min-width: 214px;
  }
`

export const UploadInfoBanner = styled.div`
  label: UploadInfoBanner;
  background-color: ${(props) => props.theme.colors.warning2} !important;
  color: ${(props) => props.theme.colors.warningContrast} !important;
  font-size: 14px;
  min-height: 80px;
  line-height: 80px;
  margin: 0px !important;
  width: 100%;
`

export const CenterAlignDiv = styled.div`
  label: CenterAlignDiv;
  display: flex;
  align-items: top;
  > svg {
    height: auto;
  }
`

export const BannerTextDiv = styled(Col)`
  label: BannerTextDiv;
  margin-bottom: 24px;
`

export const BannerContentDiv = styled.div`
  label: BannerContentDiv;
  display: flex;
  @media (max-width: 719px) {
    flex-direction: column;
  }
`

export const BannerTitleText = styled.h1`
  label: BannerTitleText;
  color: #fff !important;
  font-size: 30pt !important;
  text-align: left;
  font-weight: bold;
  margin-left: 26px;
  @media (max-width: 719px) {
    margin-left: 22px;
  }
`

export const BannerSubtitleText = styled.h2`
  label: BannerSubtitleText;
  color: #fff !important;
  font-size: 14pt !important;
  font-weight: bold !important;
  text-align: left;
  margin-top: 36px;
  text-transform: none !important;
`

export const BannerText = styled.div`
  label: BannerText;
  color: #fff;
  font-weight: normal;
  font-size: 14pt;
  text-align: left;
  line-height: 30px !important;
`

export const BannerButtonColDiv = styled.div`
  label: BannerButtonColDiv;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-items: baseline;
  height: 100%;
  > a {
    width: 100%;
    @media (max-width: 719px) {
      margin-bottom: 15px;
    }
  }
`

export const InfoIcon = styled(MdInfo)`
  label: InfoIcon;
  color: ${(props) => props.theme.colors.warningContrast};
  min-width: 20px;
  position: absolute;
  left: 6px;
  top: 11px;
`

export const WarningIcon = styled(MdWarning)`
  label: WarningIcon;
  color: ${(props) => props.theme.colors.warningContrast};
  min-width: 20px;
  position: absolute;
  left: 6px;
  top: 11px;
`

export const SmileyIcon = styled(MdSentimentSatisfied)`
  label: SmileyIcon;
  color: ${(props) => props.theme.colors.alertGreen};
  min-width: 20px;
  position: absolute;
  left: 6px;
  top: 11px;
`

export const TickIcon = styled(MdCheckCircle)`
  label: TickIcon;
  color: ${(props) => props.theme.colors.warningContrast};
  min-width: 20px;
  position: absolute;
  left: 6px;
  top: 11px;
`

export const ErrorIcon = styled(MdError)`
  label: ErrorIcon;
  color: ${(props) => props.theme.colors.danger};
  min-width: 20px;
  position: absolute;
  left: 6px;
  top: 11px;
`

export const SetTableHeadingBlock = styled('div')`
  label: SetTableHeadingBlock;
  @media (max-width: 719px) {
    flex-direction: column;
  }
  display: flex;
  justify-content: space-between;
  background: ${(props) => props.theme.backgrounds.backGround1};
  width: 100%;
  border-radius: inherit;
  padding: 24px;
  border-color: ${(props) => props.theme.colors.borderColor};
  border-style: solid;
  border-width: 1px 1px 0px 1px;
  border-radius: 5px 5px 0 0;
  > span:last-child {
    font-weight: bold;
    font-size: 14px;
    text-align: right;
  }
  span:nth-child(2) {
    min-width: 20%;
  }
`

export const SetTableDocHeading = styled('span')`
  label: SetTableDocHeading;
  color: ${(props) => props.theme.colors.primary};
  
  font-weight: bold;
  font-size: 24px;
`

export const SetSubText = styled('div')`
  label: SetSubText;
  position: relative;
  > div {
    top: -25px;
    position: absolute;
  }
`
export const SetTableRightInfo = styled.div`
  label: SetTableRightInfo;
  margin-top: 15px;
  display: flex;
  align-items: end;
  flex-direction: column;
  @media (max-width: 719px) {
    margin-top: 28px;
    align-items: start;
  }
`

export const SignButtonContainer = styled('div')`
  label: SignButtonContainer;
  padding-top: 24px;
  text-align: right;
  padding-right: 3%;
  @media (max-width: 719px) {
    text-align: center;
    padding-right: 15px;
    padding-left: 15px;
  }
`
export const AdobeText = styled(`div`)`
  label: AdobeText;
  font-size: 12px;
  color: darkblue;
  font-style: italic;
  margin-left: 6px;
`
export const ContentContainer = styled(`div`)`
  label: ContentContainer;
  max-width: 94%;
  border-radius: 5px;
  box-shadow: 1px 1px 5px 0px ${(props) => props.theme.colors.boxShadow};
`

export const CustomerSignedDiv = styled.div`
  label: CustomerSignedDiv;
  color: ${(props) => props.theme.colors.textDarkblack};
  font-size: ${(props) => props.theme.font.size.smaller};
  margin-left: 27px;
  margin-top: 6px;
  text-align: right;
  @media (max-width: 719px) {
    font-size: 12px;
    margin-left: 0px;
  }
`

export const DocumentBlock = styled('div')`
  label: DocumentBlock;
  border-bottom: 1px solid ${(props) => props.theme.colors.borderColor};
  margin: 0 -1.25rem;
  padding: 9px 54px;
`

export const DocumentAccordionTitle = styled.div`
  label: DocumentAccordionTitle;
  margin-left: 52px;
  position: absolute;
  top: 15px;
  z-index: 5;
  max-width: 80%;
  @media (max-width: 759px) {
    font-size: 12px;
    max-width: 220px;
    top: 11px;
    margin-left: 18px;
  }
`

export const DocumentAccordionTitleText = styled.span`
  label: DocumentAccordionTitleText;
  font-weight: bold;
  color: ${(props) => props.theme.colors.textDarkblack};
  margin-left: 6px;
`

export const DocumentAccordionTitleIcon = styled.div`
  label: DocumentAccordionTitleIcon;
  & svg {
    height: 22px;
    position: relative;
    top: -2px;
  }

  @media (max-width: 759px) {
    display: none;
  }
`

export const DocumentPrompt = styled.span`
  label: DocumentPrompt;
  font-weight: bold;
  font-size: ${(props) => props.theme.font.size.medium};
  margin-left: 6px;
  white-space: nowrap;
  color: ${(props) => props.theme.colors.textDarkblack};
  text-align: right;
  @media (max-width: 950px) {
    font-size: 14px;
  }
  @media (max-width: 719px) {
    font-size: 12px;
    font-weight: normal;
  }
`

export const DocumentAccordion = styled(AccordionCard)`
  label: DocumentAccordion;
  border-top: 0;
  box-shadow: 1px 1px 5px 0px ${(props) => props.theme.colors.boxShadow};
  border-radius: 0 0 5px 5px !important;
  z-index: 1;
  > div > div {
    padding-top: 0;
    padding-bottom: 0;
  }
`

export const AllDoneDiv = styled.div`
  label: AllDoneDiv;
  height: 300px;
  box-shadow: 1px 1px 5px 0px ${(props) => props.theme.colors.boxShadow};
  border-radius: 0 0 5px 5px;
  border-color: ${(props) => props.theme.colors.borderColor};
  border-style: solid;
  border-width: 0px 1px 1px 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: ${(props) => props.theme.colors.textDarkblack};
  font-size: 30px;
  font-weight: bold;
`

export const DropBoxContainer = styled.div`
  label: DropBoxContainer;
  margin: 0px 20px 0px 60px;
  width: 100%;
`

export const DroppingAreaBlock = styled.div`
  label: DroppingAreaBlock;
  margin: 60px;
  display: flex;
  justify-content: space-between;
`

export const DroppingArea = styled.div`
  label: DroppingArea;
  padding: 42px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 18px;
  border: 1px dashed;

  > button {
    font-size: 14px !important;
    font-weight: 700 !important;
    padding: 9px 18px !important;
    max-width: 200px;
    margin-top: 12px;
  }
`

export const NotificationArea = styled.div`
  label: notificationArea;
  background: ${(props) => props.theme.colors.warning2};
  padding: 30px;
  margin-bottom: 21px;
  > h3 {
    font-size: 18px;
  }
  ul > li {
    font-size: 16px;
  }
`

export const BlackButton = styled(PrimaryButton)`
  label: BlackButton;
  background: #000;
  border: solid 1px black;
  margin-top: 24px;
  @media (max-width: 719px) {
    margin-top: 0px;
  }
`